import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import styles from './ViewSwitcher.module.scss';
import {SwitchButtons} from '../../../../components/SwitchButtons';
import {
  TYPE_PHYSICAL,
  TYPE_VIRTUAL,
  VIEW_ONLINE,
  VIEW_PHYSICAL,
} from '../../constants';
import Context from '../../context';

export const ViewSwitcher = ({viewmode, onChange}) => {
  const {dataTable} = useContext(Context);

  const countPhys = (acc, cur) =>
    acc + Number(cur.primaryType === TYPE_PHYSICAL);
  const countVirt = (acc, cur) =>
    acc + Number(cur.primaryType === TYPE_VIRTUAL);

  const countPhysicalGroups = dataTable.reduce(countPhys, 0);
  const countOnlineGroups = dataTable.reduce(countVirt, 0);

  const buttons = [
    {value: VIEW_PHYSICAL, label: `Physical Groups (${countPhysicalGroups})`},
    {value: VIEW_ONLINE, label: `Online Groups (${countOnlineGroups})`},
  ];

  const handleClick = value => {
    if (onChange && value !== viewmode) {
      onChange(value);
    }
  };

  useEffect(() => {
    if (countPhysicalGroups === 0 && countOnlineGroups !== 0)
      onChange(VIEW_ONLINE);

    if (countOnlineGroups === 0 && countPhysicalGroups !== 0)
      onChange(VIEW_PHYSICAL);
  }, [dataTable, countOnlineGroups, countPhysicalGroups, onChange]);

  return (
    <div className={styles.wrap}>
      <SwitchButtons
        buttons={buttons}
        current={viewmode}
        onClick={handleClick}
      />
    </div>
  );
};

ViewSwitcher.propTypes = {
  viewmode: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

ViewSwitcher.defaultProps = {
  onChange: () => null,
};
